import React, { useCallback, useMemo } from 'react';
import GeoDuck from 'ducks/geo-duck';
import ScribeSavedPoiDuck from 'ducks/scribe-saved-poi-duck';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addressDetailOverlaySelector } from 'selectors/geo-selectors';
import uuidV4 from 'uuid/v4';
import { geoOverlayType } from 'constants/geo-constants';
import CommonOverlay from './common-overlay';
import AddressDetailPanel from './address-detail/address-detail-panel';

const AddressDetailOverlay = ({ addressDetailOverlay, dispatch }) => {
  const {
    addressDetailOverlayVisible = false,
    overlayType,
  } = addressDetailOverlay;

  const onClose = useCallback(
    () => {
      dispatch(ScribeSavedPoiDuck.creators.cancelEditingSavedPOI());
      dispatch(GeoDuck.creators.closeAddressDetailOverlay());
    },
    [overlayType],
  );

  const ContentComponent = useMemo(
    () => {
      switch (overlayType) {
        // TODO
        case geoOverlayType.addressDetail: {
          return AddressDetailPanel;
        }
        default: {
          return null;
        }
      }
    },
    [overlayType],
  );

  return (
    <CommonOverlay
      // TODO: replace key with other id
      overlayKey={uuidV4()}
      visible={addressDetailOverlayVisible}
      onClose={onClose}
    >
      {ContentComponent && <ContentComponent />}
    </CommonOverlay>
  );
};

AddressDetailOverlay.propTypes = {
  addressDetailOverlay: PropTypes.shape({}),
  dispatch: PropTypes.func.isRequired,
};

AddressDetailOverlay.defaultProps = {
  addressDetailOverlay: undefined,
};

export default connect(state => ({
  addressDetailOverlay: addressDetailOverlaySelector(state),
}))(AddressDetailOverlay);
